module.exports = __webpack_public_path__ + "img/xinxi.ebcc9e9e.png";